import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./EventsInProgress.module.scss";
import FlexChild from "layouts/flex/FlexChild";
import Inline from "layouts/container/Inline";
import CustomIcon from "components/icons/CustomIcon";
import Center from "layouts/wrapper/Center";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import clsx from "classnames";
import CustomButton from "components/buttons/CustomButton";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { adminRequester } from "App";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import Flex from "layouts/flex/Flex";

function EventsInProgress() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isMounted, setMounted] = useState(false);
  const [promotion, setPromotion] = useState();
  const [reload, setReload] = useState(false);
  const onPromotionRegClick = () => {
    navigate(`/admin/promotion/register`, { replace: true });
  };
  const onPromotionDetailClick = (row) => {
    // NiceModal.show("promotionDetail", { data: row });
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (isMounted) {
      // requester.getPromotion((result) => {
      //   setPromotion(result.data);
      
      // });
      adminRequester.getPromotions({ pr_status: "continue" }, (result) =>
        setPromotion(result.promotions)
      );
      //   setPromotion(contentData);
    }
  }, [isMounted]);
  useEffect(() => {
    if (reload) {
      adminRequester.getPromotions({ pr_status: "continue" }, (result) =>
        setPromotion(result.promotions)
      );
      setReload(false);
    }
  }, [reload]);

  //   const contentData = [
  //     {
  //       type: "할인",
  //       color: "#5471e6",
  //       title: "신제품 출시 할인 이벤트",
  //       start: "2023-07-17 09:05",
  //       end: "2023-07-07 09:05",
  //     },
  //     {
  //       type: "증정",
  //       color: "#e84518",
  //       title: "얼려먹구싶오 5개 구매시 2개 추가증정 이벤트",
  //       start: "2023-07-17 09:05",
  //       end: "2023-07-07 09:05",
  //     },
  //     {
  //       type: "출석체크",
  //       color: "#383e57",
  //       title: "7일 연속 출석 체크 성공하면 30% 할인쿠폰 증정",
  //       start: "2023-07-17 09:05",
  //       end: "2023-07-07 09:05",
  //     },
  //     {
  //       type: "할인",
  //       color: "#5471e6",
  //       title: "맥스쿨 출시 기념 3+2 이벤트",
  //       start: "2023-07-17 09:05",
  //       end: "2023-07-07 09:05",
  //     },
  //   ];

  const onDeleteClick = (row) => {
    NiceModal.show("confirm", {
      message: "이벤트를 종료시키겠습니까?",
      confirmText: "종료",
      cancelText: t("cancel"),
      onConfirm: () => deletePromotion(row),
      // onCancel: () => {},
    });
  };
  const deletePromotion = (row) => {
    const now = new Date();
    switch (row.type) {
      case "discount": {
        adminRequester.updateDiscount(
          row.id,
          {
            starts_at: new Date(
              Math.min(new Date(row.start_date).getTime(), now.getTime())
            ),
          },
          () =>
            adminRequester.updateDiscount(
              row.id,
              {
                ends_at: now,
              },
              () => setReload(true)
            )
        );
        break;
      }
      case "event": {
        adminRequester.updateEvent(row.id, { end_date: new Date() }, () =>
          setReload(true)
        );
        break;
      }
      default: {
        break;
      }
    }

  };

  const formatDateTime = (dateStr) => {
    let dateObj = new Date(dateStr);

    let year = dateObj.getFullYear();
    let month = String(dateObj.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 1을 더해야 합니다.
    let day = String(dateObj.getDate()).padStart(2, "0");
    let hours = String(dateObj.getHours()).padStart(2, "0");
    let minutes = String(dateObj.getMinutes()).padStart(2, "0");

    return `${year}년 ${month}월 ${day}일 ${hours}:${minutes}`;
  };
  const openDetail = (row) => {
    
    NiceModal.show("promotionDetail", { data: row });
  };
  const body = useRef();
  const component = useRef([]);

  return (
    <VerticalFlex Ref={body} gap={10} height="100%">
      <FlexChild height="min-content" Ref={(el) => (component.current[0] = el)}>
        <HorizontalFlex>
          <FlexChild>
            <div
              style={{
                width: "100%",
                textAlign: "left",
                fontSize: 18,
                paddingBottom: "8px",
                fontWeight: "700",
              }}
            >
              프로모션
            </div>
          </FlexChild>
          <FlexChild width="max-content">
            <CustomButton text={"추가"} onClick={onPromotionRegClick} />
          </FlexChild>
        </HorizontalFlex>
      </FlexChild>
      <FlexChild>
        <VerticalFlex height="max-content" className={style.container}>
          <FlexChild
            height="min-content"
            Ref={(el) => (component.current[1] = el)}
          >
            <div className={style.label}>
              <HorizontalFlex gap={10}>
                <FlexChild width={"max-content"}>
                  <CustomIcon name={"eventsInProgress"} width={25} />
                </FlexChild>
                <FlexChild>
                  <P>진행 중 이벤트</P>
                </FlexChild>
              </HorizontalFlex>
            </div>
          </FlexChild>
          <FlexChild
            height={
              body.current?.clientHeight -
              component?.current?.reduce((acc, now) => {
                return acc + (now?.clientHeight || 0);
              }, 0) -
              9 //gap
            }
          >
            <div className={style.contentArea}>
              <table className={style.table}>
                <thead className={style.thead}>
                  <tr>
                    <th className={style.th} width="10%">
                      타입
                    </th>
                    <th className={style.th} width="20%">
                      이벤트명
                    </th>
                    <th className={style.th}>
                      <div>
                        <Inline>
                          <P>시작일 </P>
                          {/* <CustomIcon name={"downAngle"} width={10} /> */}
                        </Inline>
                      </div>
                    </th>
                    <th className={style.th}>
                      <div>
                        <Inline>
                          <P>종료일 </P>
                          {/* <CustomIcon name={"downAngle"} width={7} /> */}
                        </Inline>
                      </div>
                    </th>
                    <th width="10%"></th>
                  </tr>
                </thead>
                <tbody>
                  {promotion &&
                    promotion.map((row, index) => {
                      return (
                        <tr key={index} className={style.tr}>
                          <td
                            className={style.td}
                            onClick={() => openDetail(row)}
                          >
                            <div
                              className={style.tdLabel}
                              style={{
                                backgroundColor:
                                  row.type === "event" ? "#e84518" : "#5471e6",
                              }}
                            >
                              {t(row.type)}
                            </div>
                          </td>
                          <td
                            className={style.td}
                            onClick={() => openDetail(row)}
                          >
                            {row.title ? row.title : "데이터 없음"}
                          </td>
                          <td
                            className={style.td}
                            onClick={() => openDetail(row)}
                          >
                            {formatDateTime(row.start_date)}
                          </td>
                          <td
                            className={style.td}
                            onClick={() => openDetail(row)}
                          >
                            {formatDateTime(row.end_date)}
                          </td>
                          <td className={style.td}>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className={style.deleteIconArea}
                                onClick={() => onDeleteClick(row)}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    position: "absolute",
                                    top: "-2px",
                                  }}
                                >
                                  <CustomIcon icon name={"delete"} width={15} />
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  {promotion &&
                    promotion?.length < 6 &&
                    [0, 1, 2, 3, 4, 5]
                      .filter((f) => f >= promotion?.length)
                      .map((index) => (
                        <tr key={`empty_${index}`} className={style.tr_e}>
                          <td className={style.td}>
                            <P color="rgba(0,0,0,0)"> </P>
                          </td>
                          <td className={style.td} />
                          <td className={style.td} />
                          <td className={style.td} />
                          <td className={style.td} />
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
          </FlexChild>
        </VerticalFlex>
      </FlexChild>
    </VerticalFlex>
  );
}

export default EventsInProgress;
